'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/* ----------------------- useForceUpdate ----------------------- */
var useForceUpdate = function useForceUpdate() {
  var _React$useState = React__default["default"].useState(),
    _React$useState2 = _rollupPluginBabelHelpers.slicedToArray(_React$useState, 2),
    updateState = _React$useState2[1];
  var forceUpdate = React__default["default"].useCallback(function () {
    return updateState({});
  }, []);
  return forceUpdate;
};

exports.useForceUpdate = useForceUpdate;
